const state = {
    muid: '',
    status: "",
    subject: "",
    sender: "",
    points: '',
    date: "",
    forward_to: "",
    email_body: "",
    isloading: false,
    panelist_id: '',
    start_time: 0,
    end_time: 0,
    first_name:"",
    last_name:"",
    age:"",
    panelistemail:"",
    state:"",
    forwardeddata:[],
    subjectdata:'',
    htmlbody:'',
    panelistCore:'',
    panelistScore:'',
    emailRead:'',
    indexName:'',
    deleted:'',
}

export default state
